import React from 'react'
import { Row } from 'antd'
import AvatarIcon from '../../../../assets/icons/avatar.png'
import {
  Image,
  MenuContainer,
  MenuItem,
  MenuText
} from '../../../../shared.style'

const MenuAccountBinProfile = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem onClick={() => history.push(`/account/bin/profile`)}>
          <Image src={AvatarIcon} alt="profile" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>โปรไฟล์</MenuText>
      </Row>
    </MenuContainer>
  )
}

export default MenuAccountBinProfile



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuAccountBinProfile/index.js